import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MessageService } from '../../../core/service/message.service';
import { RentalObjectCategory } from '../../../rent/model/const/enums';
import { DwellingService } from '../../../rent/service/data/dwelling.service';
import { OtherRentalObjectService } from '../../../rent/service/data/other-rental-object.service';
import { ParkingService } from '../../../rent/service/data/parking.service';
import { PremisesService } from '../../../rent/service/data/premises.service';
import { ResidentialProperty } from '../../model/residential-property';
import { NonResidentialProperty } from '../../model/non-residential-property';

@Component({
  selector: 'app-overview',
  templateUrl: './system-overview.component.html',
  styleUrls: ['./system-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SystemOverviewComponent implements OnInit {
  constructor(
    private readonly dwellingService: DwellingService,
    private readonly otherRentalObjectService: OtherRentalObjectService,
    private readonly parkingService: ParkingService,
    private readonly premisesService: PremisesService,
    private readonly messageService: MessageService
  ) {}

  dwelling: ResidentialProperty = new ResidentialProperty({ category: RentalObjectCategory.Dwelling });
  otherRentalObject: NonResidentialProperty = new NonResidentialProperty({ category: RentalObjectCategory.Other });
  parking: NonResidentialProperty = new NonResidentialProperty({ category: RentalObjectCategory.Parking });
  premises: ResidentialProperty = new ResidentialProperty({ category: RentalObjectCategory.Premises });

  ngOnInit(): void {
    this.dwellingService.getStatistics().subscribe({
      next: data => {
        data.category = RentalObjectCategory.Dwelling;
        this.dwelling = new ResidentialProperty(data);
      },
      error: error => this.messageService.showError(error),
    });

    this.otherRentalObjectService.getStatistics().subscribe({
      next: data => {
        data.category = RentalObjectCategory.Other;
        this.otherRentalObject = new NonResidentialProperty(data);
      },
      error: error => this.messageService.showError(error),
    });

    this.parkingService.getStatistics().subscribe({
      next: data => {
        data.category = RentalObjectCategory.Parking;
        this.parking = new NonResidentialProperty(data);
      },
      error: error => this.messageService.showError(error),
    });

    this.premisesService.getStatistics().subscribe({
      next: data => {
        data.category = RentalObjectCategory.Premises;
        this.premises = new ResidentialProperty(data);
      },
      error: error => this.messageService.showError(error),
    });
  }
}
